<template>
    <EChart
            theme="ovilia-green"
            :auto-resize="autoResize"
            v-bind="$props"
            @click="(params) => $emit('click', params)"
    />
</template>

<script>
    import 'echarts/lib/chart/line';
    import 'echarts/lib/component/tooltip'
    import 'echarts/lib/component/legend'
    import 'echarts/lib/component/title'
    //custom theme
    import ECharts from 'vue-echarts'
    import theme from './theme.json'

    ECharts.registerTheme('ovilia-green', theme);
    export default {
        name: 'linechart',
        props: {
            options: Object,
            theme: [String, Object],
            initOptions: Object,
            group: String,
            autoResize: {
                type: Boolean,
                default: true
            },
            watchShallow: Boolean,
            manualUpdate: Boolean
        },
        components: {
            EChart: ECharts,
        },
    }

</script>

<style>

</style>
